/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Task_CreatedInputs */

const cs_event_task_created = /** @type {(inputs: Event_Task_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol vytvořen`)
};

const en_event_task_created = /** @type {(inputs: Event_Task_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task created`)
};

/**
* | output |
* | --- |
* | "Task created" |
*
* @param {Event_Task_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_task_created = /** @type {((inputs?: Event_Task_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Task_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_task_created(inputs)
	return cs_event_task_created(inputs)
});